<template>
  <div class="rj-page-card">
    <p style="font-size:16px;font-weight:800">
      发票扫描件
    </p>

    <el-upload
      action=""
      multiple
      :show-file-list="false"
      :http-request="uploadaction"
      style="display: inline-block; margin: 10px 0"
    >
      <el-button type="primary" :loading="tableLoading">
        上传文件
      </el-button>
    </el-upload>

    <el-table v-loading="tableLoading" :data="tableData" border>
      <el-table-column prop="rfileName" label="文件名称" align="left" fixed="left">
        <template v-slot="{row}">
          <el-button type="text" style="margin-left: 10px" @click="openContract(row.rFileCode)">
            {{ row.rFileName }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="rUpdatedBy" label="上传人" align="left" />
      <el-table-column prop="rCreatedTime" label="上传时间" align="left" />
      <el-table-column prop="rUpdatedTime" label="最后更新时间" align="left" />
      <el-table-column prop="pname" label="操作" align="left" fixed="right">
        <template v-slot="{row}">
          <el-popover v-model="row.removeVisible" width="160">
            <p style="line-height: 30px">
              确认删除该文件吗?
            </p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="row.removeVisible = false">
                取消
              </el-button>
              <el-button type="primary" size="mini" @click="removeFile(row)">
                确定
              </el-button>
            </div>
            <el-button slot="reference" type="text" style="color: #F56C6C;">
              删除
            </el-button>
          </el-popover>
          <el-button type="text" style="margin-left: 10px" @click="downOneFile(row.rFileCode)">
            下载
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <a ref="downTag" :href="fileserveDownUrl" style="display:none;" />
  </div>
</template>

<script>
import { attachmentGetToken, deleteReturnsAttachment, getUrlByFileID, saveReturnsAttachment, getReturnsContractAttachment } from '@/API';
import AxiosApi from '@/API/fileAxios';

export default {
  data () {
    return {
      uplaodToken: {},
      tableLoading: false,
      tableData: [],
      fileserveDownUrl: ''
    };
  },

  created () {
    this.getUploadToken();
    this.searchFiles();
  },

  methods: {
    getUploadToken () {
      attachmentGetToken().then((res) => {
        let { status, data } = res.data;
        if (status === '200') {
          this.uplaodToken = data;
        }
      });
    },

    checkSpecialCharacters (str) {
    // 规则对象(flag)
      var flag = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\]<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]");
      // 判断 even 是否包含特殊字符
      if (flag.test(str)) {
        return true;
      } else {
        return false;
      }
    },

    uploadaction (upload) {
      if (this.checkSpecialCharacters(upload.file.name)) {
        this.$message.error('文件名中不能包含特殊字符！');
        return;
      }

      const form = new FormData();
      form.append('files', upload.file);
      this.tableLoading = true;

      AxiosApi.post(`${this.uplaodToken.uploadUrl}?Token=${this.uplaodToken.token}`,
        form,
        {
          headers: { 'Content-Type': 'multipart/form-data' }
        }).then((res) => {
        let { status, data } = res.data;
        if (status === '200') {
          this.submitfile(data);
          this.$message.success(`文件“${upload.file.name}”,上传成功.`);
        } else {
          this.$message.error(`文件“${upload.file.name}”,上传失败.`);
        }
      }).catch(() => {
        this.tableLoading = false;
        this.$message.error(`文件“${upload.file.name}”,上传失败.`);
      });
    },

    // 查询
    searchFiles () {
      this.tableLoading = true;
      getReturnsContractAttachment(this.$route.query.rcontractId, 3)
        .then((res) => {
          const { status, data } = res.data;
          this.tableLoading = false;
          if (status === '200') {
            this.tableData = data;
          }
        }).catch(() => {
          this.tableLoading = false;
        });
    },

    // 保存
    submitfile (data) {
      let params = [{
        rFileName: data[0].FullName,
        rFileCode: data[0].FID,
        rContractId: this.$route.query.rcontractId,
        rFileType: 3
      }];

      saveReturnsAttachment(params)
        .then((res) => {
          const { status } = res.data;
          this.tableLoading = false;
          if (status === '200') {
            this.searchFiles();
          }
        }).catch(() => {
          this.tableLoading = false;
        });
    },

    // 删除
    removeFile (row) {
      let params = {
        contractId: row.rContractId,
        attachmentId: row.rId
      };
      this.tableLoading = true;

      deleteReturnsAttachment(params)
        .then((res) => {
          const { status } = res.data;
          if (status === '200') {
            this.searchFiles();
          } else {
            this.tableLoading = false;
          }
        }).catch(() => {
          this.tableLoading = false;
        });
    },

    // 预览
    openContract (fileCode) {
      getUrlByFileID(fileCode)
        .then((res) => {
          const { status, data } = res.data;
          if (status === '200') {
            window.open(data);
          }
        });
    },

    // 下载
    downOneFile (id) {
      this.fileserveDownUrl = this.uplaodToken.downloadUrl + `/${id}?Token=${this.uplaodToken.token}`;
      this.$nextTick(() => {
        this.$refs.downTag.click();
      });
    }
  }

};
</script>
